import SISUsuarioClienteClient from '@/api/SistemaDKP/sis-usuario_cliente.client';
import { ErrorMessage } from '@/libs/Error';
import Store from '@/store';

export default class SLSUsuarioRepresentanteService {
  constructor() {
    this.client = new SISUsuarioClienteClient();
    this.error = new ErrorMessage();
    this.store = Store;
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      console.log('data', data);
      this.store.commit('SISUsuarioCliente/setUsuariosRepresentantes', data);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async create(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Usuario Representante');
    }
  }

  async findOneUsuario(id) {
    try {
      const { data } = await this.client.findOneUsuario(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Usuario Representante');
    }
  }

  async findOneRepresentante(id) {
    try {
      const { data: response } = await this.client.findOneRepresentante(id, data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Usuario Representante');
    }
  }

  async destroy(usuarioid, representanteid) {
    try {
      const { data } = await this.client.destroy(usuarioid, representanteid);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Usuario Representante');
    }
  }

  async listarClienteNaoSelecionados(queries = this.store.getters['SISUsuarioCliente/getRepresentantesNaoSelecionados']) {
    try {
      const { data: { data, ...pagination } } = await this.client.listarClienteNaoSelecionados(queries);
      this.store.commit('SISUsuarioCliente/setClientesNaoSelecionados', data);
      this.store.commit('SISUsuarioCliente/setFiltersNaoSelecioando', {
        ...pagination,
      });
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async listarClienteSelecionados(queries = this.store.getters['SISUsuarioCliente/getClientesSelecionados']) {
    try {
      const { data: { data, ...pagination } } = await this.client.listarClienteSelecionados(queries);
      this.store.commit('SISUsuarioCliente/setClientesSelecionados', data);
      this.store.commit('SISUsuarioCliente/setFiltersSelecionados', pagination);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async removerTodosClienteSelecionados(usuarioId) {
    try {
      const { data } = await this.client.removerTodosClienteSelecionados(usuarioId);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Usuario Representante');
    }
  }

  async removerSelecionadoClienteSelecionado(dataRemover) {
    try {
      const { data } = await this.client.removerSelecionadoClienteSelecionado(dataRemover);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Usuario Representante');
    }
  }

  async adicionarTodosCliente(usuarioId) {
    try {
      const { data } = await this.client.adicionarTodosCliente(usuarioId);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Usuario Representante');
    }
  }

  async adicionarSelecionadoClienteNaoSelecionado(data) {
    try {
      const { data: response } = await this.client.adicionarSelecionadoClienteNaoSelecionado(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Usuario Representante');
    }
  }
}
